import { render, staticRenderFns } from "./PrivacyPolicyApp.vue?vue&type=template&id=4a6d9eaf"
import script from "./PrivacyPolicyApp.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyApp.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyApp.vue?vue&type=style&index=0&id=4a6d9eaf&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports